//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"AngleResult",1,0],[1,"AngleResultExp",0,"Expression",0],[0,"AngleStep",1,0],[1,"AngleStepExp",0,"Expression",0],[0,"BlankArea",1,0],[1,"BlankAreaExp",0,"Expression",0],[0,"BoundarySegment",1,0],[0,"HeightStep",1,0],[0,"IsReNest",1,0],[0,"LayoutType",1,0],[0,"MinimumDistance",1,0],[1,"MinimumDistanceExp",0,"Expression",0],[0,"PitchResult",1,0],[1,"PitchResultExp",0,"Expression",0],[1,"SelectObject",0,"ScCollector",0],[0,"StripWidthResult",1,0],[1,"StripWidthResultExp",0,"Expression",0],[0,"Utilization",1,0],[0,"WebDistance",1,0],[1,"WebDistanceExp",0,"Expression",0]],[[[],"LayoutCalculation",{},0,0]],[]];
SPLM.Tooling.BlankNestingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.BlankNestingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.BlankNestingBuilder.LayoutTypeSpecification = Object.freeze({
    "Rectangle" : "Rectangle", "Parallelogram" : "Parallelogram", "Trapezoid" : "Trapezoid", "OneUp" : "OneUp", "TwoUp" : "TwoUp", "TwoPair" : "TwoPair"});

export default SPLM;